import "../../styles/userAccount.css";
import "../../styles/Navigation.css";
import Navbar from "../../components/player/Navbar.tsx";
import Footer from '../../components/player/Footer.jsx';
import { useUser } from "../../context/UserContext.tsx";
import { Link } from "react-router-dom";
import { formatNumbers, isFreePlayBet } from "../../helpers/functions.tsx";
import { usePlayerMyBets } from "../../hooks/usePlayerMyBets.ts";
import { usePlayerChrome } from "../../hooks/usePlayerChrome.ts";
// import { updateUserImage } from "../services/LoginService.tsx";
// import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
// import { storage } from "../services/Firebase.js";


const UserAccount = () => {
    usePlayerChrome();

    const {user} = useUser();
    const { bets: myBets } = usePlayerMyBets();
    const pendingAmount = myBets.reduce(
        (sum, bet) => isFreePlayBet(bet) ? sum : sum + (bet.bet || 0),
        0,
    );
    // const defaultImage = require("../images/default image.png");
    // const [alertClass, setAlertClass] = useState("alert alert-danger d-none");
    // const maxSizeInBytes = 3 * 1024 * 1024;

    // const fileHandler = async (e) => {
    //     const file = e.target.files && e.target.files[0];
    //     if (file) {
    //       if (file.size > maxSizeInBytes) {
    //         setAlertClass("alert alert-danger");
    //         setTimeout(() => {
    //           setAlertClass("alert alert-danger d-none");
    //         }, 4000);
    //         return;
    //       }
    //       try {
    //         const userId = user?.userName;
    //         const refFile = ref(storage, `user/${userId}/profile-picture`);
    //         await uploadBytes(refFile, file);
    //         const url = await getDownloadURL(refFile);
    //         await updateUserImage(userId, url);
    //       } catch (error) {
    //         console.error("Error uploading file", error);
    //       } finally {
    //         e.target.value = null;
    //       }
    //     }
    //   };

    return (
        <div className="player-layout">
            <Navbar />
            <div className="player-main-surface">
                <div className="container-fluid container-account col-md-8">
                    <div className="row">
                        <div className="col">
                            <span className="teko account">Account settings</span>
                            <Link to="/messaging" className='btnMessages'>messages</Link>
                        </div>
                    </div>
                    <span className="line-account"></span>
                    <div className="row oppp">
                        <div className="col container-text-account">
                            <span className="teko dynamic-text">UserName </span>
                            <input id="username-input" className="user-input" value={user?.userName} readOnly></input>
                        </div>
                    </div>
                    <div className="row oppp">
                        <div className="col container-text-account">
                            <span className="teko dynamic-text">Email</span>
                            <input id="email-input" className="user-input" value={user?.email} readOnly></input>
                        </div>
                    </div>
                    <span className="line-account"></span>
                    <div className="row oppp">
                        <div className="col"></div>
                        <div className="col probability-Container">
                            <span className="teko dynamic-text">Avaliabble</span>
                        </div>
                        <div className="col probability-Container">
                            <span className="teko dynamic-text">Pending</span>
                        </div>
                        <div className="col probability-Container">
                            <span className="teko dynamic-text">Balance</span>
                        </div>
                        <div className="col"></div>
                    </div>
                    <div className="row">
                        <div className="col"></div>
                        <div className="col probability-Container">
                            <span className="teko dynamic-text">{formatNumbers(user?.available)}</span>
                        </div>
                        <div className="col probability-Container">
                            <span className="teko dynamic-text">{formatNumbers(pendingAmount)}</span>
                        </div>
                        <div className="col probability-Container">
                            <span className="teko dynamic-text">{formatNumbers(user?.balance)}</span>
                        </div>
                        <div className="col"></div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )

};

export default UserAccount;